/* global fetchDepartmentsUrl fetchDepartmentCostCentersUrl fetchDepPositionsTreeUrl fetchAllDepPositionsTreeUrl fetchCcPositionsTreeUrl fetchDepUnassignedUrl fetchCcUnassignedUrl treeUpdateUrl organigramEventId organigramFilterPreference organigramContext */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import WorkforceOrganigramByDepartment from './WorkforceOrganigramByDepartment';

export default function OrganisationalCharts() {
    return (
        <div className="tw-h-full tw-px-6 tw-py-6.5 tw-rounded-lg tw-shadow-primary">
            <WorkforceOrganigramByDepartment
                fetchDepartmentsUrl={fetchDepartmentsUrl}
                fetchDepartmentCostCentersUrl={fetchDepartmentCostCentersUrl}
                fetchDepPositionsTreeUrl={fetchDepPositionsTreeUrl}
                fetchAllDepPositionsTreeUrl={fetchAllDepPositionsTreeUrl}
                fetchCcPositionsTreeUrl={fetchCcPositionsTreeUrl}
                fetchDepUnassignedUrl={typeof fetchDepUnassignedUrl !== 'undefined' ? fetchDepUnassignedUrl : ''}
                fetchCcUnassignedUrl={typeof fetchCcUnassignedUrl !== 'undefined' ? fetchCcUnassignedUrl : ''}
                treeUpdateUrl={treeUpdateUrl}
                eventId={typeof organigramEventId !== 'undefined' ? organigramEventId : null}
                initialFilterState={typeof organigramFilterPreference !== 'undefined' ? organigramFilterPreference : {}}
                fullPreferenceValue={typeof organigramFilterPreference !== 'undefined' ? organigramFilterPreference : {}}
                exportContext={typeof organigramContext !== 'undefined' ? organigramContext : {}}
            />
        </div>
    );
}

if (document.getElementById('OrganisationalCharts')) {
    var root = document.getElementById('OrganisationalCharts');
    ReactDOM.render(
        <App>
            <OrganisationalCharts />
        </App>,
        root,
    );
}
